import React, { useState } from 'react';
import PropTypes from 'prop-types';

const BrandedLandingPage = ({
    landingPagesCreated, landingPageLinkToCopy, landingPagesLeft, openLandingBuilder = () => { },
}) => {
    const [urlCopiedLanding, setUrlCopiedLanding] = useState(false);

    const copyURL = (link, type) => {
        navigator.clipboard.writeText(link)
            .then(() => {
                if (type === 'landing') setUrlCopiedLanding(true);

                // Reset the urlCopied state after 3000 milliseconds (3 seconds)
                setTimeout(() => {
                    if (type === 'landing') setUrlCopiedLanding(false);
                }, 3000);
            })
            .catch((error) => {
                console.error('Unable to copy to clipboard:', error);
            });
    };

    return (
        <div className='branded-landing-page' style={{
            border: '1px solid #C6C6C9',
            margin: '4px 0',
            borderRadius: 5,
        }}>
            <div className='info-section' style={{ padding: 12 }}>
                <h3 className="font-serif margin-t-0px margin-b-4px font-blue-16">Create a Branded Landing Page</h3>
                <p className="font-w-3 margin-0px">Elevate your video page with an eye-catching backdrop.</p>
                <p className="font-blue-48 margin-t-8px margin-b-8px">
                    <a href="https://community.thankview.com/t/q6hp05d/how-to-landing-page-builder" target="_blank" rel='noreferrer'>
                        Learn about branded landing pages
                    </a>
                </p>
                {
                    landingPagesCreated > 1 && <p className="width-100 font-w-3">{`You have created ${landingPagesCreated} landing pages.`}</p>
                }

                {
                    landingPagesCreated === 1 && <p className="width-100 font-w-3">You have created 1 landing page.</p>
                }

                {
                    landingPagesCreated === 0 && <p className="width-100 font-w-3">You have not created any landing pages yet.</p>
                }

                {
                    landingPagesLeft > 0 && <div />
                }
            </div>
            <hr className="margin-0px" style={{ height: '0px' }} />
            <div className='buttons-section' style={{ display: 'flex', justifyContent: 'space-between', padding: '8px' }}>
                <button
                    type="button"
                    className={`btn margin-b-16px sm-margin-b-0px width-100 sm-width-auto font-size-14px ${urlCopiedLanding ? 'btn--green-97' : 'btn--secondary'}`}
                    style={{ whiteSpace: 'nowrap' }}
                    onClick={() => copyURL(landingPageLinkToCopy, 'landing')}
                >
                    <i className="fa fa-link" style={{ fontSize: 'small' }}></i> {urlCopiedLanding ? 'Copied!' : 'Copy Shareable Link'}
                </button>
                <button type="button" className="btn btn--primary-alt btn margin-l-8px margin-b-16px sm-margin-b-0px width-100 sm-width-auto font-size-14px" style={{ whiteSpace: 'nowrap' }} onClick={(event) => openLandingBuilder(event)}><i className="fas fa-image" style={{ fontSize: 'small' }}></i> Create Landing Page</button>
            </div>
        </div>
    );
};

BrandedLandingPage.propTypes = {
    landingPagesCreated: PropTypes.number,
    landingPagesLeft: PropTypes.number,
    landingPageLinkToCopy: PropTypes.string,
    openLandingBuilder: PropTypes.func,
};

export default BrandedLandingPage;
